import {LiveShoppingEvent} from '../../../../grpc_client/grips/protos/shared/live_shopping_event';
import {
  formatDateWithWrittenMonth,
  getTimeFromDate,
  isLaterThanToday,
  isToday,
  isTomorrow,
} from '../../../../localization/date';
import {Log} from '../../../../utils/logger/log';
import {
  LiveShoppingTranslations,
  useLiveShoppingTranslationContext,
} from '../../context/TranslationProvider';

export const useComputeEventDetails = (event: LiveShoppingEvent) => {
  const translations = useLiveShoppingTranslationContext();

  const isLive = event.state?.$case === 'live';
  const isEnded = event.state?.$case === 'ended';

  let eventDate = new Date(Date.now());

  if (event.state?.$case === 'scheduled' && event.state.scheduled.startsAt) {
    eventDate = new Date(event.state.scheduled.startsAt);
  }

  if (
    event.state?.$case === 'scheduledSoon' &&
    event.state.scheduledSoon.startsAt
  ) {
    eventDate = new Date(event.state.scheduledSoon.startsAt);
  }

  let eventStartMessage = '';

  if (isLive) {
    eventStartMessage = translations.liveNow;
  }

  if (event.state?.$case === 'ended' && event.state.ended.endedAt) {
    try {
      // when deserialized on the FE we get a string instead of Date
      eventStartMessage = formatDateWithWrittenMonth(
        new Date(event.state.ended.endedAt),
        translations.locale,
      );
    } catch (error) {
      Log.error('Failed parsing liveshopping end date', {
        error,
        additionalData: {ended: JSON.stringify(event.state.ended)},
      });
    }
  }

  if (
    event.state?.$case === 'scheduled' ||
    event.state?.$case === 'scheduledSoon'
  ) {
    eventStartMessage = getScheduledEventStartMessage(eventDate, translations);
  }

  return {
    isLive,
    isEventToday: isToday(eventDate),
    isScheduledAfterToday: isLaterThanToday(eventDate),
    isEnded,
    eventStartMessage,
  };
};

const getScheduledEventStartMessage = (
  eventDate: Date,
  t: LiveShoppingTranslations,
) => {
  const isEventToday = isToday(eventDate);
  const isEventTomorrow = isTomorrow(eventDate);

  if (isEventToday) {
    return getEventDateTimeString(t.today, eventDate);
  }

  if (isEventTomorrow) {
    return getEventDateTimeString(t.tomorrow, eventDate);
  }

  return getEventDateTimeString(
    formatDateWithWrittenMonth(eventDate, t.locale),
    eventDate,
  );
};

const getEventDateTimeString = (day: string, eventDate: Date) => {
  return `${day} ${getTimeFromDate(eventDate)}`;
};
